import { Box, Button, Container, Divider } from "@mui/material";
import * as React from "react";
import { Colors } from "../../../theme/colors";
import logo from "../../../images/textLogo.png";
import { useNavigate } from "react-router-dom";
import MenuLink from "./MenuLink";
import { Routes } from "../../../routes/Routes";

import LogoutIcon from "@mui/icons-material/Logout";
import LanguageIcon from "@mui/icons-material/Language";

import useLoginContainer from "../../../containers/useLoginContainer";
import MenuIcon from "@mui/icons-material/Menu";
import IconButton from "@mui/material/IconButton";
import { useState } from "react";
import Drawer from "@mui/material/Drawer";
import List from "@mui/material/List";
import HomeWorkIcon from "@mui/icons-material/HomeWork";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import HomeIcon from "@mui/icons-material/Home";
import NotificationsIcon from "@mui/icons-material/Notifications";

import { useLanguage } from "../../../hooks/useLanguage";
import { LanguagesApp } from "../../../hooks/useLanguage/languagesApp";
import { useContent } from "../../../content/useContent";

const classes = {
  borderBottom: {
    py: 1,
    borderBottom: `3px solid ${Colors.secondary}`,
    position: "fixed",
    width: "100%",
    zIndex: 102,
    backgroundColor: Colors.primary,
  },
  between: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },

  logo: {
    width: "105px",
  },

  item: {
    ml: { md: 2, xs: 0 },
    my: { md: 0, xs: 1 },
    cursor: "pointer",
    opacity: 0.8,
    fontWeight: "600",
    "&:hover": {
      opacity: 1,
    },
  },
  list: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    height: "100%",
    pb: 2,
  },
};

const Nav: React.FC = () => {
  const { handleLogout } = useLoginContainer();
  const { nav } = useContent();
  const { setLanguage, language } = useLanguage();
  const navigate = useNavigate();
  const [showMenu, setShowMenu] = useState(false);

  const handleLanguage = () => {
    setShowMenu(false);
    if (language === LanguagesApp.Arabic) {
      setLanguage(LanguagesApp.English);
    } else {
      setLanguage(LanguagesApp.Arabic);
    }
  };

  return (
    <Box sx={classes.borderBottom}>
      <Container sx={classes.between}>
        <img
          src={logo}
          alt="logo"
          style={classes.logo}
          onClick={() => navigate(Routes.home)}
        />
        <IconButton onClick={() => setShowMenu(true)}>
          <MenuIcon color="secondary" sx={{ fontSize: 40 }} />
        </IconButton>
      </Container>
      <Drawer anchor="right" open={showMenu} onClose={() => setShowMenu(false)}>
        <Box
          sx={{ width: 250, height: "100%" }}
          onClick={() => setShowMenu(false)}
        >
          <List sx={classes.list}>
            <Box>
              <MenuLink text={nav.home} Icon={<HomeIcon />} to={Routes.home} />
              <MenuLink
                text={nav.events}
                Icon={<CalendarMonthIcon />}
                to={Routes.events}
              />
              <MenuLink
                text={nav.directories}
                Icon={<HomeWorkIcon />}
                to={Routes.directories}
              />
              <MenuLink
                text={nav.pushNotifications}
                Icon={<NotificationsIcon />}
                to={Routes.pushNotifications}
              />
            </Box>
            <Box sx={{ px: 2 }}>
              <Divider />

              <Button
                variant="contained"
                startIcon={<LanguageIcon />}
                onClick={handleLanguage}
                sx={{ width: "100%", mt: 2 }}
                color="secondary"
              >
                {nav.language}
              </Button>

              <Button
                variant="contained"
                startIcon={<LogoutIcon />}
                onClick={handleLogout}
                sx={{ width: "100%", mt: 2 }}
              >
                {nav.logout}
              </Button>
            </Box>
          </List>
        </Box>
      </Drawer>
    </Box>
  );
};

export default Nav;
